module.exports = __webpack_public_path__ + "static/img/helh433.179d709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh433.png
// module id = ZvCa
// module chunks = 5